import Button from '@/components/Button';
import { usePasswordForm } from './usePasswordForm';
import { PasswordField } from './PasswordField';

export function ProfilePassword() {
  const { isLoading, control, handleSubmit, page } = usePasswordForm();
  const {
    yourPasswordTitle,
    yourCurrentPasswordField,
    yourNewPasswordField,
    confirmYourPasswordField,
    confirmYourChangesCta,
  } = page?.profilePasswordSection || {};
  return (
    <div className="mt-sh-30">
      <form onSubmit={handleSubmit} className="flex cursor-pointer flex-col items-start gap-2">
        <h1 className=" text-sh-md font-bold">{yourPasswordTitle}</h1>

        <PasswordField name="currentPassword" label={yourCurrentPasswordField} control={control} />
        <PasswordField name="password" label={yourNewPasswordField} control={control} />
        <PasswordField name="passwordConfirmation" label={confirmYourPasswordField} control={control} />

        <Button theme="solid" type="submit" loading={isLoading} className=" mt-8">
          {confirmYourChangesCta}
        </Button>
      </form>
    </div>
  );
}
